// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1lRDw","header":"PatientQuestionnaire_header__21Lsl","info":"PatientQuestionnaire_info__1vTi3"};